import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  constructor(
    private meta: Meta,
    private title: Title,
    private translate: TranslateService
  ) {}
  public arrayPath: string[] = [];

  ngOnInit(): void {
    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4] === 'jp') {
      this.meta.addTag({
        name: 'description',
        content:
          '会社名: 株式会社 日本医薬品 |〒542-0081 大阪府大阪市中央区南船場３丁目７−２７| 代表: 佐藤康介',
      });
      this.title.setTitle('日本医薬品 | 会社概要');
      this.translate.use('jp');
      this.translate.setDefaultLang('jp');
    } else {
      this.meta.addTag({
        name: 'description',
        content:
          'Company Name, Japan Pharma Inc. |Headquarters, 3-7-27 Rm 4-C, Minamisenba, Chuo-ku, Osaka-shi, Osaka 542-0081 | Representative, Masanori Hishitani',
      });
      this.title.setTitle('JAPAN PHARMA INC. | about');
      this.translate.use('en');
      this.translate.setDefaultLang('en');
    }
  }
}
